import { VehicleModel } from '@/lib/models/vehicle/types';
import { getVehicleFuselage, isFreighterAircraft } from '@/utils/vehicle'; // @TODO move to model utils

export const getVehicleDescription = (vehicle: VehicleModel) => {
  if (vehicle?.featureSet?.airplane || vehicle?.featureSet?.truck?.isRFS) {
    const vehicleFuselage = getVehicleFuselage(vehicle.featureSet);
    const isFreighter = isFreighterAircraft(vehicle);
    return `${isFreighter ? 'Freighter' : 'PAX'} / ${vehicleFuselage || 'RFS'}`;
  }
  // @TODO handle other modes
  return '';
};
